import React, { Component, Suspense } from "react";
import { Redirect } from "react-router-dom";
import { withTranslation } from "react-multi-lang";
import { withAlert } from "react-alert";
import $ from "jquery";
import "bootstrap";

const Administratorheader = React.lazy(() => import("./subpages/Administratorheader.jsx"));
const Organisation = React.lazy(() => import("./subpages/Organisation.jsx"));
const Menu = React.lazy(() => import("./subpages/Menu.jsx"));

class AdministratorHome extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    componentWillUnmount() {
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
    }

    onlogout(e) {
        // store.dispatch(replacestate(defalutreduxState));
        setTimeout(() => { this.props.history.push("/administrator"); }, 100);
    }

    render() {
        if (!$.session.get("TenantLoginUser")) {
            return <Redirect to="/administrator" />;
        }
        return (
            <div id="idElnBody" className="adminPageContainer">
                <Suspense fallback={<div></div>}>
                    <Menu />
                </Suspense>
                <div id="bodycontent" className="d-flex flex-column">
                    <Suspense fallback={<div></div>}>
                        <Administratorheader pageName="Organisation Details" onlogout={this.onlogout.bind(this)} />
                    </Suspense>
                    <Suspense fallback={<div></div>}>
                        <Organisation />
                    </Suspense>
                </div>
            </div>
        );
    }
}
export default withAlert()(withTranslation(AdministratorHome));